<script setup>
import { computed, reactive } from 'vue'

const props = defineProps({
  document: { required: true, type: [Object, null], default: {} },
})

const state = reactive({
  isImage: computed(() => ['jpg', 'jpeg', 'gif', 'png', 'webp'].includes(props.document?.fileExtension)),
  isPdf:   computed(() => props.document?.fileExtension == 'pdf'),
  isMsOffice: computed(() => ['doc', 'docx', 'xls', 'xlsx'].includes(props.document?.fileExtension)),
})


const docIcon = computed(() => {
  let ext = props.document?.fileExtension
  if (state.isImage) {
    // if (ext == 'jpeg') ext = 'jpg'
    // return `ph ph-file-${ext}`
    return `ph ph-image`
  }
  if (state.isPdf) return `ph ph-file-pdf`
  if (state.isMsOffice) {
    if (ext.startsWith('doc')) return `ph ph-microsoft-word-logo`
    if (ext.startsWith('xls')) return `ph ph-microsoft-excel-logo`
  }

})

</script>

<template lang="pug">
div
  i(:class="docIcon")
  //- .text-lg {{ document.fileExtension }}
  //- pre {{ docIcon }}
  //- pre {{ state }}
</template>